module.exports = __webpack_public_path__ + "media/images/lb/322-9903080b4c80a518c63cfc2a4be715e9.svg";